import React from 'react'
import { useNextOccurrencesCore } from '../hooks/use-next-occurrences-core'
import { NextOccurrencesPreview as View } from './next-occurrences-preview'
import { IScheduleData } from '../types'

export interface INextOccurrencesFromScheduleProps extends IScheduleData {
  title?: string
  maxCount?: number
  emptyMessage?: string
}

export const NextOccurrencesFromSchedule: React.FC<INextOccurrencesFromScheduleProps> = ({
  schedule,
  timeZone,
  dateStart,
  dateEnd,
  title,
  maxCount,
  emptyMessage,
}) => {
  const { occurrences, loading, currTz } = useNextOccurrencesCore({
    data: { schedule, timeZone, dateStart, dateEnd },
  })
  return (
    <View
      occurrences={occurrences}
      tz={currTz}
      loading={loading}
      title={title}
      maxCount={maxCount}
      emptyMessage={emptyMessage}
    />
  )
}
